import { render, staticRenderFns } from "./ModelInfoLayout.vue?vue&type=template&id=fd344a2c"
import script from "./ModelInfoLayout.vue?vue&type=script&lang=ts"
export * from "./ModelInfoLayout.vue?vue&type=script&lang=ts"
import style0 from "./ModelInfoLayout.vue?vue&type=style&index=0&id=fd344a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports